import { Injectable, signal, computed } from '@angular/core';
import { GLOBAL_SEARCH_ITEMS } from '../core/constants/globalSearch.const';

@Injectable({ providedIn: 'root' })
export class GlobalSearchService {
  private term = signal('');

  readonly results = computed(() => {
    const q = this.term().toLowerCase().trim();
    if (!q) return [];

    return GLOBAL_SEARCH_ITEMS.filter(
      item =>
        item.title.toLowerCase().includes(q) ||
        item.module.toLowerCase().includes(q) ||
        item.keywords.some(k => k.includes(q))
    );
  });

  search(value: string) {
    this.term.set(value);
  }

  clear() {
    this.term.set('');
  }
}
